const itemColection = document.getElementsByClassName("item-collection");
const btnMenuOne = document.getElementById("select-one");
const btnMenuTwo = document.getElementById("select-two")

btnMenuTwo.addEventListener("click", () =>{
    for(let i=0; i<itemColection.length; i++){
        itemColection[i].classList.add("half_space")
    }

    btnMenuTwo.classList.add("active")
    btnMenuOne.classList.remove("active")
})

btnMenuOne.addEventListener("click", () => {
    for(let i=0; i<itemColection.length; i++){
        itemColection[i].classList.remove("half_space")
    }

    btnMenuTwo.classList.remove("active")
    btnMenuOne.classList.add("active")
});

/*

setTimeout(function(){
    let ancho = screen.width;
    let mainMenu = document.getElementById("shopify-section-header").offsetHeight;
    let menuCollections = document.querySelector(".container_nav-list");
    console.log(ancho)

    if(ancho >= 1200){
        menuCollections.style.top= "44px"
      }else{
          menuCollections.style.top = mainMenu + "px";
      }
}, 5000)

    setTimeout(function(){
    var banner = document.getElementById("cb-shipping-bar");
    let hijoBanner = document.querySelector(".cbShippingFixed")



    if(hijoBanner != null) {
        let menu = document.getElementById("shopify-section-header").style.paddingTop= "44px";
        }else {
        let menu = document.getElementById("shopify-section-header").style.paddingTop= "0"; 
        }
    }, 4000)

        let ancho = screen.width;
        let mainMenu = document.getElementById("shopify-section-header");

        if(ancho <= 1199){
        mainMenu.style.position= "sticky"
        }
*/